import Layer, { EASE_OUT_QUINT } from "@/classes/Layer.js";
import { overwriteCss } from "@/utils.js";

const SUBJECT_FIRST_KEYFRAME_STYLE = { opacity: 0, transform: "scale(0.5)" };

export default class YouTubeLayer extends Layer {
  /**
   * @param {Spinner} spinner
   * @param {HTMLElement} node
   * @param {HTMLElement} [subjectNode]
   * @class
   */
  constructor(spinner, node, subjectNode) {
    super(spinner, node, subjectNode);
    overwriteCss(this.subject, SUBJECT_FIRST_KEYFRAME_STYLE);

    this.container = this.host.parentNode;
    this.closeButtonNode = this.getElmById("close-youtube");
    this.player = document.createElement("iframe");
    this.player.title = "YouTube video player";
    this.player.allow =
      "autoplay; fullscreen; accelerometer; gyroscope; picture-in-picture";

    this.subject.appendChild(this.player);
    this.closeButtonNode.addEventListener("pointerup", this.close.bind(this));

    spinner.on("keydown", (event) => {
      if (!this.isOpen) {
        return;
      }

      if (event.key === "Escape") {
        this.close();
      }
    });
  }

  get isOpen() {
    return this.host.style.display !== "none";
  }

  show(videoId) {
    this.animateNode(
      this.host,
      [{ opacity: 0 }, { opacity: 1 }],
      {
        easing: EASE_OUT_QUINT,
        duration: 500,
      },
      () => {
        this.host.style.display = "";
      },
    );

    this.animateNode(
      this.subject,
      [SUBJECT_FIRST_KEYFRAME_STYLE, { transform: "scale(1)", opacity: 1 }],
      {
        delay: 200,
        duration: 500,
        easing: EASE_OUT_QUINT,
      },
      null,
      () => {
        this.player.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
      },
    );
  }

  close() {
    this.animateNode(
      this.host,
      [{ opacity: 1 }, { opacity: 0 }],
      {
        duration: 200,
      },
      null,
      () => {
        this.host.style.display = "none";
        overwriteCss(this.subject, SUBJECT_FIRST_KEYFRAME_STYLE);
        this.player.contentWindow.location.replace("about:blank");
      },
    );
  }
}
